import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Form } from 'react-final-form';
import { ValidationErrors } from 'final-form';

import { CreateDisplayCategoryFormRenderComponent } from './CreateDisplayCategoryFormRenderComponent';

import {
  DisplayCategoryFormProps,
  DisplayCategoryFormRenderProps,
  DisplayCategoryFormValues,
} from '../types';

export interface CreateDisplayCategoryPageProps {
  createDisplayCategory: DisplayCategoryFormProps['onSubmit'];
  validate?: (values: Partial<DisplayCategoryFormValues>) => Promise<ValidationErrors>;
}

export const CreateDisplayCategoryPage: React.FC<CreateDisplayCategoryPageProps> = ({
  validate,
  createDisplayCategory,
}) => {
  const renderForm: DisplayCategoryFormProps['render'] = React.useCallback(
    ({ handleSubmit, valid, submitting }: DisplayCategoryFormRenderProps) => {
      return (
        <CreateDisplayCategoryFormRenderComponent
          handleSubmit={handleSubmit}
          disabled={!valid || submitting}
        />
      );
    },
    [],
  );

  return (
    <>
      <Helmet>
        <title>Create Display Category</title>
      </Helmet>
      <Form onSubmit={createDisplayCategory} render={renderForm} validate={validate} />
    </>
  );
};
